export const DEFAULT_SURVEY_REMINDER_MESSAGES = Object.freeze({
  ANONYMOUS: {
    en: "Hi - just a quick reminder to respond to this survey. We'd love to hear from you!",
    es: 'Hola - solo un breve recordatorio para responder a esta encuesta. ¡Nos encantaría saber de ti!',
  },
  NON_ANONYMOUS: {
    en: "Hi {{{employee.firstName}}} - just a quick reminder to respond to this survey. We'd love to hear from you!",
    es: 'Hola {{{employee.firstName}}} - solo un breve recordatorio para responder a esta encuesta. ¡Nos encantaría saber de ti!',
  },
});
